
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "documents-public-ui",
  currentProjectVersion: "static-1.35528",
  depVersions: {
  "documents-public-ui": "static-1.35528",
  "atom": "static-1.5544",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2958",
  "client-types": "static-1.510",
  "cssUtils": "static-1.1095",
  "customer-data-filters-ui": "static-1.41347",
  "customer-data-objects": "static-1.8173",
  "customer-data-property-utils": "static-1.8522",
  "documents-lib": "static-1.35533",
  "emoji-mart": "static-3.7",
  "flux-actions": "static-1.380",
  "FormsCommonComponents": "static-1.86830",
  "FormUrlGenerator": "static-2.5187",
  "foundations-theming-specialty": "static-1.2676",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.115",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.6064",
  "hs-test-utils": "static-1.8508",
  "hub-http": "static-1.6679",
  "hubspot-dlb": "static-2.1911",
  "HubStyle": "static-2.12267",
  "HubStyleTokens": "static-2.11960",
  "I18n": "static-7.1706",
  "icons": "static-2.702",
  "jasmine-immutable": "static-1.3411",
  "jasmine-runner": "static-1.6923",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7619",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.3357",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5851",
  "quartz": "static-1.7649",
  "react": "static-7.202",
  "react-dlb": "static-1.93",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17205",
  "react-select-plus": "static-1.118",
  "react-utils": "static-2.5654",
  "react-virtualized": "static-2.112",
  "reference-resolvers": "static-1.8653",
  "reference-resolvers-lite": "static-1.8581",
  "reporting-data": "static-1.69334",
  "reporting-reports": "static-1.69010",
  "reporting-snowflake": "static-1.57950",
  "reporting-testing-lib": "static-1.11267",
  "reporting-visualizations": "static-1.61408",
  "reselect": "static-3.16",
  "sales-content-partitioning": "static-1.9431",
  "sanitize": "static-1.4945",
  "sanitize-text": "static-1.8630",
  "SharedI18nStrings": "static-1.187",
  "SharedLegalStrings": "static-1.2202",
  "signup-constants": "static-1.19934",
  "signup-ui-url-generator": "static-2.8520",
  "StyleGuideUI": "static-3.518",
  "superstore": "static-1.5230",
  "tinymce": "static-6.5",
  "transmute": "static-2.97",
  "ui-addon-draggable": "static-3.5221",
  "ui-addon-form-validation": "static-1.11346",
  "ui-asset-management-lib": "static-1.11573",
  "ui-images": "static-2.1276",
  "UIComponents": "static-3.8906",
  "usage-tracker": "static-1.7793",
  "usage-tracker-container": "static-1.7783",
  "usage-tracker-core": "static-1.7643",
  "viral-links-lib": "static-1.7553",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.10111",
  "foundations-components": "static-1.8744",
  "immutable": "static-2.88",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.1427",
  "quartz-core": "static-1.6868",
  "quick-fetch": "static-1.4229",
  "raven": "static-3.5925",
  "redux": "static-4.81",
  "redux-thunk": "static-2.84",
  "rpc-client-utils": "static-1.5142",
  "ui-addon-i18n": "static-1.11619",
  "ui-addon-upgrades": "static-9.18547",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4383",
  "metrics-js": "static-1.9990",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3926",
  "quartz-webpack": "static-1.3873",
  "foundations-assets": "static-1.5357",
  "foundations-theming": "static-1.4960",
  "hub-http-janus": "static-1.905",
  "hub-http-shared-msw-handlers": "static-1.10894",
  "hubspotter-http": "static-1.4973",
  "trellis-components": "static-1.3090",
  "trellis-migration-context": "static-1.50",
  "sassPrefix": "static-1.360",
  "conversations-skeleton-state": "static-1.7607",
  "crm-message-bus": "static-1.44093",
  "customer-data-filters-ui-msw-helpers": "static-1.23782",
  "customer-data-objects-ui-components": "static-1.13506",
  "customer-data-reference-ui-components": "static-1.13645",
  "customer-data-ui-utilities": "static-1.10307",
  "events-data-lib": "static-1.717",
  "framework-builder-read-service-client": "static-1.4333",
  "hs-resources": "static-1.665",
  "immer": "static-1.105",
  "inbound-db-meta-service-client": "static-1.3773",
  "inbound-db-properties-service-client": "static-1.4150",
  "multi-account-reference-resolvers": "static-1.1481",
  "onboarding-tours": "static-1.17396",
  "pulse": "static-1.1118",
  "reporting-datasets-permissions-lib": "static-1.14762",
  "segments-client-types": "static-1.12127",
  "stylex": "static-1.46",
  "trellis-assets": "static-1.3071",
  "trellis-theming": "static-1.1471",
  "ui-addon-teams": "static-1.22007",
  "quartz-auth": "static-1.1324",
  "ui-business-units-lib": "static-1.9569",
  "usage-tracker-session-replay": "static-1.5479",
  "ai-components-ui-library": "static-1.10011",
  "ContentUtils": "static-1.69461",
  "customer-data-properties": "static-1.53020",
  "forms-ai-lib": "static-1.4980",
  "forms-utils-lib": "static-1.13331",
  "foundations-components-test-utils": "static-1.6227",
  "react-dnd-compat": "static-1.5083",
  "react-tinymce": "static-1.56263",
  "tinymce-config": "static-2.55389",
  "ui-gdpr-components": "static-1.10655",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3945",
  "HeadJS": "static-2.820",
  "framer-motion": "static-1.84",
  "hs-test-utils-bend-plugin": "static-1.3619",
  "msw": "static-1.102",
  "msw-config": "static-1.27",
  "testing-library": "static-1.164",
  "hs-locale-management": "static-1.398",
  "ui-fonts": "static-1.1222",
  "i18n-data": "static-1.234",
  "moment-timezone": "static-5.96",
  "jasmine": "static-4.4781",
  "csstype": "static-1.50",
  "beacon-keepalive-queue": "static-1.172",
  "quartz-head": "static-1.1314",
  "web-vitals": "static-1.19",
  "batch-promise": "static-1.2018",
  "external-options-client-types": "static-1.4438",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.1324",
  "frontend-preferences-client": "static-1.8392",
  "graphql": "static-1.93",
  "persist-promise": "static-1.4175",
  "reporting-client-types": "static-1.2831",
  "apollo-stack-hubspot": "static-3.99",
  "growth-payments-core": "static-1.26494",
  "hubspot-apollo-client": "static-1.5352",
  "foundations-components-legacy": "static-1.1769",
  "quartz-routing": "static-1.1079",
  "hs-story-utils": "static-1.9895",
  "react-flip-move": "static-1.83",
  "nested-table": "static-1.703",
  "seat-types-lib": "static-1.1044",
  "timezone-utils": "static-2.5703",
  "react-create-root-preference": "static-1.101",
  "bend-plugin-foundations-components": "static-1.5013",
  "floating-ui": "static-1.68",
  "react-aria": "static-1.77",
  "tanstack-table": "static-1.66",
  "opentelemetry-fe-types": "static-1.263",
  "dispatcher": "static-1.147",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.604",
  "module-federation": "static-1.38",
  "opentelemetry-fe": "static-1.638",
  "quartz-test": "static-1.1324",
  "quartz-tracking": "static-1.1028",
  "bend-plugin-chirp-manifest": "static-1.552",
  "chirp-fetch": "static-1.2375",
  "merchandise-lib": "static-1.284",
  "purchase-motions-components": "static-1.6623",
  "ts-schema": "static-1.4391",
  "bender-build-tools": "static-1.3567",
  "bend-plugin-foundations-theming": "static-1.3443",
  "base-ui": "static-1.27",
  "react-day-picker": "static-1.15",
  "tanstack-virtual": "static-1.43",
  "restore-request-side-panel-lib": "static-1.2024",
  "react-immutable-render-mixin": "static-1.9",
  "apollo-link-hub-http": "static-2.5059",
  "conditional-properties-service-client": "static-1.4111",
  "crm-pipelines-api-client-types": "static-1.4441",
  "event-emitter": "static-1.1434",
  "fdsr-migration-layer": "static-1.483",
  "multi-currency-client-types": "static-1.4006",
  "getting-started-shared-tasks": "static-1.19554",
  "growth-data-modal": "static-1.6129",
  "growth-onboarding-confetti": "static-1.3532",
  "growth-onboarding-next-action-utils": "static-1.2975",
  "navigation-components": "static-1.19161",
  "nest": "static-1.707",
  "onboarding-tours-client": "static-1.5611",
  "onboarding-tours-utils": "static-1.1463",
  "ui-shepherd-react": "static-3.10749",
  "ui-shepherd-tracker": "static-1.8130",
  "ui-universal-auth": "static-1.9732",
  "user-context": "static-1.5525",
  "bend-plugin-pulse": "static-1.621",
  "fast-json-patch": "static-1.74",
  "crm-index-associations-lib": "static-1.6922",
  "stylex-utils": "static-1.173",
  "hubspotter-http-shared-msw-handlers": "static-1.10892",
  "magpie-lib": "static-1.5905",
  "navigation-messaging": "static-1.8488",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.23849",
  "copilot-toolkit": "static-1.12138",
  "cms-field-types": "static-1.5283",
  "content-icons-ui": "static-1.2454",
  "integrations-lib": "static-1.17421",
  "calling-global-api": "static-1.66174",
  "calling-internal-common": "static-1.31797",
  "calling-lifecycle-internal": "static-1.67556",
  "calling-lifecycle-messages": "static-1.59849",
  "commerce-products-lib": "static-1.10902",
  "crm-index-visualization-core": "static-1.4752",
  "crm-links": "static-1.6781",
  "customer-data-properties-shared-msw-handlers": "static-1.10221",
  "file-manager-components": "static-1.24829",
  "formula-editor": "static-1.15007",
  "google-libphonenumber": "static-1.49",
  "inbounddb-objects-service-types": "static-1.4518",
  "meetings-icalendar-utils-lib": "static-1.1106",
  "object-builder-ui-client": "static-1.50036",
  "pipeline-validation-client-types": "static-1.4279",
  "property-value-citations": "static-1.3634",
  "smart-data-capture-core": "static-1.465",
  "smart-property-lib": "static-1.8645",
  "tiered-pricing": "static-1.2259",
  "topics-actions-lib": "static-1.656",
  "trellis-ext-i18n": "static-1.1381",
  "trial-components-library": "static-1.14370",
  "ui-addon-iframeable": "static-1.9546",
  "zustand": "static-1.89",
  "final-form": "static-1.83",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.82",
  "rich-text-lib": "static-1.20546",
  "tinymce-themes": "static-1.57359",
  "data-token-picker": "static-1.17127",
  "hub-http-contrib": "static-1.3502",
  "interframe": "static-3.5212",
  "tinymce-data": "static-1.41474",
  "tinymce-plugins": "static-1.58503",
  "ui-addon-sales-email": "static-1.5674",
  "onboarding-scopes": "static-1.6924",
  "ui-addon-opt": "static-4.8875",
  "hubspot-apollo-cache": "static-1.811",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.622",
  "opentelemetry-web": "static-1.22",
  "purchase-motions-api": "static-1.6626",
  "onboarding-data-sync-lib": "static-1.2835",
  "growth-onboarding-next-action-components": "static-1.3003",
  "user-context-client": "static-1.4982",
  "idb-keyval": "static-1.55",
  "magpie-types": "static-1.5365",
  "reactive-lib": "static-1.1192",
  "simple-logging-lib": "static-1.3523",
  "custom-vendor-connection-lib": "static-1.296",
  "unified-auth-core-lib": "static-1.1528",
  "getting-started-shared-tasks-store": "static-1.18672",
  "nav-meta": "static-1.30798",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.2149",
  "integrations-error-boundary-lib": "static-1.14836",
  "integrations-tracking-lib": "static-1.6091",
  "native-integrations-shared-strings": "static-1.8234",
  "redux-observable": "static-1.79",
  "ReduxMessenger": "static-2.10841",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31804",
  "shared-worker-versioning": "static-1.11512",
  "calling-usage-tracker": "static-1.7009",
  "customer-data-tracking": "static-1.7341",
  "voice-sms-access-library": "static-1.2429",
  "commerce-permissions": "static-1.1258",
  "products-iframe-lib": "static-1.8900",
  "products-ui-components-shared-msw-handlers": "static-1.11276",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10977",
  "sales-views-client-types": "static-1.4727",
  "framework-data-schema-resolvers": "static-1.7364",
  "location-customization-utils-lib": "static-1.10410",
  "apollo-dlb": "static-3.98",
  "immerable": "static-1.4614",
  "poll-commands": "static-1.3948",
  "video-components-external": "static-1.12422",
  "video-data-lib": "static-1.36080",
  "bark-lib": "static-1.17003",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.106",
  "crm-properties-common-lib": "static-1.6365",
  "react-codemirror": "static-1.11112",
  "data-agent-kit": "static-1.908",
  "data-agent-test-utils": "static-1.452",
  "data-agent-utils": "static-1.921",
  "feedback-loader": "static-1.30055",
  "fsm": "static-1.4231",
  "policy-lib": "static-1.7282",
  "react-colorpicker": "static-2.10681",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.11040",
  "embedded-academy-lib": "static-1.15995",
  "hubs-service-types": "static-1.1738",
  "nudge-client-utils": "static-1.3413",
  "salesImages": "static-1.729",
  "FileManagerLib": "static-1.40469",
  "NamespacedHubStyle": "static-2.9365",
  "FileManagerCore": "static-1.40328",
  "content-assistance-lib": "static-1.8417",
  "layout-dnd-components": "static-1.13221",
  "layout-dnd-utils": "static-1.12196",
  "ui-addon-emoji-picker": "static-1.10334",
  "ui-brand-identity-lib": "static-1.16934",
  "InboxConnectUtils": "static-4.15838",
  "meetings-connect-utils-lib": "static-1.8089",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1127",
  "breeze-engine-core": "static-1.1427",
  "highlight.js": "static-1.90",
  "universal-page-editor-lib": "static-1.3482",
  "calling-orchestration-schema": "static-1.37206",
  "framework-data-schema-quick-fetch": "static-1.7269",
  "crm-record-cards-service-types": "static-1.3871",
  "content-media-composition-data-lib": "static-1.13584",
  "content-media-compositions": "static-2.17591",
  "media-bridge-lib": "static-1.19635",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16661",
  "browser-eslint": "static-2.57",
  "trellis-story-utils": "static-1.4971",
  "enrichment-settings-lib": "static-1.227",
  "storybook-react": "static-1.44",
  "academy-common-lib": "static-1.15456",
  "nudge-custom-function-registry": "static-1.3170",
  "nudge-renderer-utils": "static-1.3489",
  "whisper-core-api": "static-1.7626",
  "audio-components": "static-1.6564",
  "FileManagerImages": "static-1.37980",
  "video-components": "static-1.14424",
  "breeze-artifacts-sdk": "static-1.927",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.65",
  "urlinator": "static-1.4987",
  "video-embed": "static-1.36914",
  "ui-addon-video-player": "static-1.9094",
  "ui-coaching-tips": "static-1.29580",
  "ContentData": "static-1.69536",
  "layout-data-lib": "static-1.10521",
  "academy-service-client": "static-1.4163",
  "croppie": "static-2.10",
  "SafeStorage": "static-1.4867",
  "trellis-ecosystem": "static-1.7845",
  "ui-addon-react-router-dom": "static-1.9999",
  "wootric-nps": "static-1.7295",
  "social-insights-client-types": "static-1.22921",
  "outpost": "static-1.4601",
  "growth-onboarding-feedback-components": "static-1.7055",
  "advanced-menus-core": "static-1.15810",
  "advanced-menus-lib": "static-1.12565",
  "ExportDialog": "static-6.10843",
  "ui-memberships-settings-lib": "static-1.35178",
  "marketplace-ui-apps-core": "static-1.19575",
  "marketplace-ui-common": "static-1.21043",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15809",
  "simple-menus-lib": "static-1.17326",
  "settings-ui-lib": "static-1.13000",
  "developer-experience-shared-components": "static-1.11010",
  "immutable-less": "static-1.5125",
  "marketplace-ui-client-types": "static-1.18450",
  "ui-addon-integrations-directory-panel": "static-2.8425",
  "ui-extensibility-client-types": "static-1.4388",
  "ai-settings-ui-library": "static-1.8578",
  "ui-product-approvals-common": "static-1.1570",
  "apps-service-types": "static-1.4096",
  "oauth-service-types": "static-1.4608",
  "simple-data-table": "static-1.3811"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.35528",
  "atom": "/atom/static-1.5544",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2958",
  "client-types": "/client-types/static-1.510",
  "cssUtils": "/cssUtils/static-1.1095",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41347",
  "customer-data-objects": "/customer-data-objects/static-1.8173",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8522",
  "documents-lib": "/documents-lib/static-1.35533",
  "emoji-mart": "/emoji-mart/static-3.7",
  "flux-actions": "/flux-actions/static-1.380",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86830",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5187",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2676",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.115",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.6064",
  "hs-test-utils": "/hs-test-utils/static-1.8508",
  "hub-http": "/hub-http/static-1.6679",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyle": "/HubStyle/static-2.12267",
  "HubStyleTokens": "/HubStyleTokens/static-2.11960",
  "I18n": "/I18n/static-7.1706",
  "icons": "/icons/static-2.702",
  "jasmine-immutable": "/jasmine-immutable/static-1.3411",
  "jasmine-runner": "/jasmine-runner/static-1.6923",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7619",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.3357",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5851",
  "quartz": "/quartz/static-1.7649",
  "react": "/react/static-7.202",
  "react-dlb": "/react-dlb/static-1.93",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17205",
  "react-select-plus": "/react-select-plus/static-1.118",
  "react-utils": "/react-utils/static-2.5654",
  "react-virtualized": "/react-virtualized/static-2.112",
  "reference-resolvers": "/reference-resolvers/static-1.8653",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8581",
  "reporting-data": "/reporting-data/static-1.69334",
  "reporting-reports": "/reporting-reports/static-1.69010",
  "reporting-snowflake": "/reporting-snowflake/static-1.57950",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.11267",
  "reporting-visualizations": "/reporting-visualizations/static-1.61408",
  "reselect": "/reselect/static-3.16",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9431",
  "sanitize": "/sanitize/static-1.4945",
  "sanitize-text": "/sanitize-text/static-1.8630",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.187",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2202",
  "signup-constants": "/signup-constants/static-1.19934",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8520",
  "StyleGuideUI": "/StyleGuideUI/static-3.518",
  "superstore": "/superstore/static-1.5230",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.97",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5221",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11346",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11573",
  "ui-images": "/ui-images/static-2.1276",
  "UIComponents": "/UIComponents/static-3.8906",
  "usage-tracker": "/usage-tracker/static-1.7793",
  "usage-tracker-container": "/usage-tracker-container/static-1.7783",
  "usage-tracker-core": "/usage-tracker-core/static-1.7643",
  "viral-links-lib": "/viral-links-lib/static-1.7553",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.10111",
  "foundations-components": "/foundations-components/static-1.8744",
  "immutable": "/immutable/static-2.88",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.1427",
  "quartz-core": "/quartz-core/static-1.6868",
  "quick-fetch": "/quick-fetch/static-1.4229",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.81",
  "redux-thunk": "/redux-thunk/static-2.84",
  "rpc-client-utils": "/rpc-client-utils/static-1.5142",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11619",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18547",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "metrics-js": "/metrics-js/static-1.9990",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3926",
  "quartz-webpack": "/quartz-webpack/static-1.3873",
  "foundations-assets": "/foundations-assets/static-1.5357",
  "foundations-theming": "/foundations-theming/static-1.4960",
  "hub-http-janus": "/hub-http-janus/static-1.905",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10894",
  "hubspotter-http": "/hubspotter-http/static-1.4973",
  "trellis-components": "/trellis-components/static-1.3090",
  "trellis-migration-context": "/trellis-migration-context/static-1.50",
  "sassPrefix": "/sassPrefix/static-1.360",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7607",
  "crm-message-bus": "/crm-message-bus/static-1.44093",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23782",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13506",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13645",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10307",
  "events-data-lib": "/events-data-lib/static-1.717",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4333",
  "hs-resources": "/hs-resources/static-1.665",
  "immer": "/immer/static-1.105",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3773",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4150",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1481",
  "onboarding-tours": "/onboarding-tours/static-1.17396",
  "pulse": "/pulse/static-1.1118",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14762",
  "segments-client-types": "/segments-client-types/static-1.12127",
  "stylex": "/stylex/static-1.46",
  "trellis-assets": "/trellis-assets/static-1.3071",
  "trellis-theming": "/trellis-theming/static-1.1471",
  "ui-addon-teams": "/ui-addon-teams/static-1.22007",
  "quartz-auth": "/quartz-auth/static-1.1324",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9569",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5479",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10011",
  "ContentUtils": "/ContentUtils/static-1.69461",
  "customer-data-properties": "/customer-data-properties/static-1.53020",
  "forms-ai-lib": "/forms-ai-lib/static-1.4980",
  "forms-utils-lib": "/forms-utils-lib/static-1.13331",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6227",
  "react-dnd-compat": "/react-dnd-compat/static-1.5083",
  "react-tinymce": "/react-tinymce/static-1.56263",
  "tinymce-config": "/tinymce-config/static-2.55389",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10655",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3945",
  "HeadJS": "/HeadJS/static-2.820",
  "framer-motion": "/framer-motion/static-1.84",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3619",
  "msw": "/msw/static-1.102",
  "msw-config": "/msw-config/static-1.27",
  "testing-library": "/testing-library/static-1.164",
  "hs-locale-management": "/hs-locale-management/static-1.398",
  "ui-fonts": "/ui-fonts/static-1.1222",
  "i18n-data": "/i18n-data/static-1.234",
  "moment-timezone": "/moment-timezone/static-5.96",
  "jasmine": "/jasmine/static-4.4781",
  "csstype": "/csstype/static-1.50",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.172",
  "quartz-head": "/quartz-head/static-1.1314",
  "web-vitals": "/web-vitals/static-1.19",
  "batch-promise": "/batch-promise/static-1.2018",
  "external-options-client-types": "/external-options-client-types/static-1.4438",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.1324",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8392",
  "graphql": "/graphql/static-1.93",
  "persist-promise": "/persist-promise/static-1.4175",
  "reporting-client-types": "/reporting-client-types/static-1.2831",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.99",
  "growth-payments-core": "/growth-payments-core/static-1.26494",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5352",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1769",
  "quartz-routing": "/quartz-routing/static-1.1079",
  "hs-story-utils": "/hs-story-utils/static-1.9895",
  "react-flip-move": "/react-flip-move/static-1.83",
  "nested-table": "/nested-table/static-1.703",
  "seat-types-lib": "/seat-types-lib/static-1.1044",
  "timezone-utils": "/timezone-utils/static-2.5703",
  "react-create-root-preference": "/react-create-root-preference/static-1.101",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5013",
  "floating-ui": "/floating-ui/static-1.68",
  "react-aria": "/react-aria/static-1.77",
  "tanstack-table": "/tanstack-table/static-1.66",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.263",
  "dispatcher": "/dispatcher/static-1.147",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.604",
  "module-federation": "/module-federation/static-1.38",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.638",
  "quartz-test": "/quartz-test/static-1.1324",
  "quartz-tracking": "/quartz-tracking/static-1.1028",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.552",
  "chirp-fetch": "/chirp-fetch/static-1.2375",
  "merchandise-lib": "/merchandise-lib/static-1.284",
  "purchase-motions-components": "/purchase-motions-components/static-1.6623",
  "ts-schema": "/ts-schema/static-1.4391",
  "bender-build-tools": "/bender-build-tools/static-1.3567",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3443",
  "base-ui": "/base-ui/static-1.27",
  "react-day-picker": "/react-day-picker/static-1.15",
  "tanstack-virtual": "/tanstack-virtual/static-1.43",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.2024",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5059",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4111",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4441",
  "event-emitter": "/event-emitter/static-1.1434",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.483",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4006",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19554",
  "growth-data-modal": "/growth-data-modal/static-1.6129",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3532",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2975",
  "navigation-components": "/navigation-components/static-1.19161",
  "nest": "/nest/static-1.707",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5611",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1463",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10749",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8130",
  "ui-universal-auth": "/ui-universal-auth/static-1.9732",
  "user-context": "/user-context/static-1.5525",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.621",
  "fast-json-patch": "/fast-json-patch/static-1.74",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6922",
  "stylex-utils": "/stylex-utils/static-1.173",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10892",
  "magpie-lib": "/magpie-lib/static-1.5905",
  "navigation-messaging": "/navigation-messaging/static-1.8488",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.23849",
  "copilot-toolkit": "/copilot-toolkit/static-1.12138",
  "cms-field-types": "/cms-field-types/static-1.5283",
  "content-icons-ui": "/content-icons-ui/static-1.2454",
  "integrations-lib": "/integrations-lib/static-1.17421",
  "calling-global-api": "/calling-global-api/static-1.66174",
  "calling-internal-common": "/calling-internal-common/static-1.31797",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67556",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59849",
  "commerce-products-lib": "/commerce-products-lib/static-1.10902",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4752",
  "crm-links": "/crm-links/static-1.6781",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10221",
  "file-manager-components": "/file-manager-components/static-1.24829",
  "formula-editor": "/formula-editor/static-1.15007",
  "google-libphonenumber": "/google-libphonenumber/static-1.49",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4518",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1106",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50036",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4279",
  "property-value-citations": "/property-value-citations/static-1.3634",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.465",
  "smart-property-lib": "/smart-property-lib/static-1.8645",
  "tiered-pricing": "/tiered-pricing/static-1.2259",
  "topics-actions-lib": "/topics-actions-lib/static-1.656",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1381",
  "trial-components-library": "/trial-components-library/static-1.14370",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9546",
  "zustand": "/zustand/static-1.89",
  "final-form": "/final-form/static-1.83",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.82",
  "rich-text-lib": "/rich-text-lib/static-1.20546",
  "tinymce-themes": "/tinymce-themes/static-1.57359",
  "data-token-picker": "/data-token-picker/static-1.17127",
  "hub-http-contrib": "/hub-http-contrib/static-1.3502",
  "interframe": "/interframe/static-3.5212",
  "tinymce-data": "/tinymce-data/static-1.41474",
  "tinymce-plugins": "/tinymce-plugins/static-1.58503",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5674",
  "onboarding-scopes": "/onboarding-scopes/static-1.6924",
  "ui-addon-opt": "/ui-addon-opt/static-4.8875",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.811",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.622",
  "opentelemetry-web": "/opentelemetry-web/static-1.22",
  "purchase-motions-api": "/purchase-motions-api/static-1.6626",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2835",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3003",
  "user-context-client": "/user-context-client/static-1.4982",
  "idb-keyval": "/idb-keyval/static-1.55",
  "magpie-types": "/magpie-types/static-1.5365",
  "reactive-lib": "/reactive-lib/static-1.1192",
  "simple-logging-lib": "/simple-logging-lib/static-1.3523",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.296",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1528",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18672",
  "nav-meta": "/nav-meta/static-1.30798",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2149",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14836",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6091",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8234",
  "redux-observable": "/redux-observable/static-1.79",
  "ReduxMessenger": "/ReduxMessenger/static-2.10841",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31804",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11512",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7009",
  "customer-data-tracking": "/customer-data-tracking/static-1.7341",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2429",
  "commerce-permissions": "/commerce-permissions/static-1.1258",
  "products-iframe-lib": "/products-iframe-lib/static-1.8900",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11276",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10977",
  "sales-views-client-types": "/sales-views-client-types/static-1.4727",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7364",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10410",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "immerable": "/immerable/static-1.4614",
  "poll-commands": "/poll-commands/static-1.3948",
  "video-components-external": "/video-components-external/static-1.12422",
  "video-data-lib": "/video-data-lib/static-1.36080",
  "bark-lib": "/bark-lib/static-1.17003",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.106",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6365",
  "react-codemirror": "/react-codemirror/static-1.11112",
  "data-agent-kit": "/data-agent-kit/static-1.908",
  "data-agent-test-utils": "/data-agent-test-utils/static-1.452",
  "data-agent-utils": "/data-agent-utils/static-1.921",
  "feedback-loader": "/feedback-loader/static-1.30055",
  "fsm": "/fsm/static-1.4231",
  "policy-lib": "/policy-lib/static-1.7282",
  "react-colorpicker": "/react-colorpicker/static-2.10681",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.11040",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15995",
  "hubs-service-types": "/hubs-service-types/static-1.1738",
  "nudge-client-utils": "/nudge-client-utils/static-1.3413",
  "salesImages": "/salesImages/static-1.729",
  "FileManagerLib": "/FileManagerLib/static-1.40469",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9365",
  "FileManagerCore": "/FileManagerCore/static-1.40328",
  "content-assistance-lib": "/content-assistance-lib/static-1.8417",
  "layout-dnd-components": "/layout-dnd-components/static-1.13221",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12196",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10334",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16934",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15838",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8089",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1127",
  "breeze-engine-core": "/breeze-engine-core/static-1.1427",
  "highlight.js": "/highlight.js/static-1.90",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3482",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37206",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7269",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3871",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13584",
  "content-media-compositions": "/content-media-compositions/static-2.17591",
  "media-bridge-lib": "/media-bridge-lib/static-1.19635",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16661",
  "browser-eslint": "/browser-eslint/static-2.57",
  "trellis-story-utils": "/trellis-story-utils/static-1.4971",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.227",
  "storybook-react": "/storybook-react/static-1.44",
  "academy-common-lib": "/academy-common-lib/static-1.15456",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3170",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3489",
  "whisper-core-api": "/whisper-core-api/static-1.7626",
  "audio-components": "/audio-components/static-1.6564",
  "FileManagerImages": "/FileManagerImages/static-1.37980",
  "video-components": "/video-components/static-1.14424",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.927",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.65",
  "urlinator": "/urlinator/static-1.4987",
  "video-embed": "/video-embed/static-1.36914",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9094",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29580",
  "ContentData": "/ContentData/static-1.69536",
  "layout-data-lib": "/layout-data-lib/static-1.10521",
  "academy-service-client": "/academy-service-client/static-1.4163",
  "croppie": "/croppie/static-2.10",
  "SafeStorage": "/SafeStorage/static-1.4867",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7845",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9999",
  "wootric-nps": "/wootric-nps/static-1.7295",
  "social-insights-client-types": "/social-insights-client-types/static-1.22921",
  "outpost": "/outpost/static-1.4601",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7055",
  "advanced-menus-core": "/advanced-menus-core/static-1.15810",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12565",
  "ExportDialog": "/ExportDialog/static-6.10843",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35178",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19575",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21043",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15809",
  "simple-menus-lib": "/simple-menus-lib/static-1.17326",
  "settings-ui-lib": "/settings-ui-lib/static-1.13000",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11010",
  "immutable-less": "/immutable-less/static-1.5125",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18450",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8425",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4388",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8578",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1570",
  "apps-service-types": "/apps-service-types/static-1.4096",
  "oauth-service-types": "/oauth-service-types/static-1.4608",
  "simple-data-table": "/simple-data-table/static-1.3811"
}
};
